// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7b928a3e","977":"75e2cd74"}[chunkId] + ".chunk.js";
};